import { type AvatarSize } from '../Avatar/types.js';
import { getAvatarSize } from '../Avatar/utils.js';
import { css, styled } from 'styled-components';

export const AvatarMask = styled.div<{ size?: AvatarSize }>`
  ${({ size = 'sm', theme }) => {
    const sizePx = `${getAvatarSize(size)}px`;
    return css`
      background-color: ${theme.colorsV2.white};
      border-radius: 50%;
      height: calc(${sizePx} + 2px);
      width: calc(${sizePx} + 2px);
      left: -1px;
      top: -1px;
      position: absolute;
      opacity: 0.7;
    `;
  }}
`;
